<script lang="ts">
	import { onMount } from 'svelte';
	import { openModal } from '$lib/stores/modal';
	import { navLinks } from '$lib/data/nav';
	import { magnetic } from '$lib/actions/magnetic';
	import logo from '$lib/assets/img/admiral-logo.svg';
	import posthog from 'posthog-js';

	let nav: HTMLElement;
	let menuOpen = $state(false);

	onMount(() => {
		const onScroll = () => {
			if (!nav) return;
			if (window.scrollY > 20) {
				nav.style.boxShadow = '0 8px 32px -12px rgba(0,0,0,0.6)';
				nav.style.background = 'rgba(5,5,9,0.85)';
			} else {
				nav.style.boxShadow = '';
				nav.style.background = 'rgba(5,5,9,0.7)';
			}
		};
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	});
</script>

<nav
	bind:this={nav}
	class="nav-enterprise sticky top-4 z-40 mx-auto mt-4 flex h-14 w-full max-w-[1280px] items-center justify-between rounded-xl py-2 pl-5 pr-3"
>
	<div class="flex items-center gap-10">
		<a href="/"><img class="w-24" src={logo} alt="Admiral" /></a>
		<ul class="hidden items-center gap-7 lg:flex">
			{#each navLinks as link}
				<li>
					<a
						href={link.href}
						target={link.external ? '_blank' : undefined}
						rel={link.external ? 'noopener' : undefined}
						class="font-display text-sm text-white/70 transition-colors hover:text-white"
					>
						{link.label}
					</a>
				</li>
			{/each}
		</ul>
	</div>
	<div class="hidden items-center gap-2 lg:flex">
		<a
			href="https://admrl.qdyn.au"
			target="_blank"
			rel="noopener"
			class="px-3 py-2 font-display text-sm text-white/70 transition-colors hover:text-white"
		>
			Sign in
		</a>
		<button
			use:magnetic
			onclick={() => {
				posthog.capture('nav_get_started_clicked', { location: 'desktop' });
				openModal();
			}}
			class="btn-primary rounded-md px-4 py-2 font-display text-sm font-medium"
		>
			Get started free
		</button>
	</div>

	<!-- Mobile -->
	<button class="cursor-pointer lg:hidden" onclick={() => (menuOpen = !menuOpen)} aria-label="Menu">
		<svg class="w-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
			<path d="M4 6h16M4 12h16M4 18h16" class="text-white" />
		</svg>
	</button>
</nav>

{#if menuOpen}
	<div
		class="fixed inset-0 z-30 bg-black/60 lg:hidden"
		onclick={() => (menuOpen = false)}
		onkeydown={() => {}}
		role="button"
		tabindex="-1"
	></div>
	<aside
		class="fixed left-0 top-0 z-40 flex h-[100vh] w-[280px] flex-col gap-4 border-r border-white/10 bg-[#050509] px-6 py-10 lg:hidden"
	>
		<ul class="flex flex-col gap-6 pt-8">
			{#each navLinks as link}
				<li>
					<a
						href={link.href}
						target={link.external ? '_blank' : undefined}
						class="font-display text-lg text-white"
						onclick={() => (menuOpen = false)}
					>
						{link.label}
					</a>
				</li>
			{/each}
		</ul>
		<div class="mt-auto flex flex-col gap-3">
			<a href="https://admrl.qdyn.au" class="py-2 text-center font-display text-sm text-white/70">
				Sign in
			</a>
			<button
				onclick={() => {
					menuOpen = false;
					posthog.capture('nav_get_started_clicked', { location: 'mobile' });
					openModal();
				}}
				class="btn-primary rounded-md px-4 py-3 font-display text-sm font-medium"
			>
				Request access
			</button>
		</div>
	</aside>
{/if}
